import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class TagsService {

  static findAllByAMTSupportEntry(token) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}tags/findAllByAMTSupportEntry?token=${token}`).then((data) => {
        resolve({ tags: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getDeviceCounts() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}tags/deviceCount`).then((data) => {
        resolve({ counts: data.data, response: data });
      }).catch((err) => {
        console.error(err);
        reject(err);
      });
    });
  }

  static getAll(options=[]) {
    return new Promise((resolve, reject) => {
      let params = options.length == 0 ? '' : '?' + options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');
      axios.get(`${ROOT}tags${params}`).then((data) => {
        resolve({ tags: data.data.content, page: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static get(tagId, detail=false) {
    return new Promise((resolve, reject) => {
      let detailParms = detail ? '?projection=detail' : '';
      axios.get(`${ROOT}tags/${tagId}${detailParms}`).then((data) => {
        resolve({ tag: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static save(tag) {
    return new Promise((resolve, reject) => {
      axios.patch(`${ROOT}tags/${tag.id}`, tag).then((data) => {
        resolve(data);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static add(tag) {
    return new Promise((resolve, reject) => {
      axios.post(`${ROOT}tags`, tag).then((data) => {
        resolve(data.data);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static listAll(filterType=null) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}tags/listAll${filterType ? `&filterType=${filterType}` : ''}`).then((data) => {
        resolve({ tags: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static listAvailableForDeviceAndGrouping(deviceGroupingId, deviceId) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}tags/${deviceGroupingId}/${deviceId}/available`).then((data) => {
        resolve({ tags: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static findChecklistDeviceTagsAssignedForGrouping(deviceGroupingId, tags) {
    return new Promise((resolve, reject) => {
      axios.post(`${ROOT}tags/${deviceGroupingId}`, tags).then((data) => {
        resolve({ tags: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static remove(tagId) {
    return new Promise((resolve, reject) => {
      axios.delete(`${ROOT}tags/${tagId}`).then((data) => {
        resolve(data);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getAllTypes() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}tags/types`).then((data) => {
        resolve({ types: data.data, response: data})
      }).catch((err) => {
        reject(err);
      });
    });
  }

}

export default TagsService;
